export default {
  setGetluckyActivityInfo(state, value) {
    state.getluckyActivityInfo = value
  },
  setGetluckySkuInfo(state, value) {
    state.getluckySkuInfo = value
  },
  setGetluckyPaymentInfo(state, value) {
    state.getluckyPaymentInfo = value
  },
  setGetluckyPartNum(state, value) {
    state.getluckyPartNum = value
  },
  setGetluckyWinRecord(state, value) {
    state.getluckyWinRecord = value
  },
}
